const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNochat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243.32,
    y: 254.58,
    width: 151.29,
    height: 4.28,
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.5,
    y: 254.58,
    width: 35.11,
    height: 4.28,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.84 418.74 355.94 258.85 357.92 258.85 365.82 418.74 363.84 418.74",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.84 418.74 355.94 258.85 357.92 258.85 365.82 418.74 363.84 418.74",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.95 418.74 391.04 258.85 393.03 258.85 400.93 418.74 398.95 418.74",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.95 418.74 391.04 258.85 393.03 258.85 400.93 418.74 398.95 418.74",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.95 418.74 391.04 258.85 393.03 258.85 400.93 418.74 398.95 418.74",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.08 418.74 281.99 258.85 280 258.85 272.1 418.74 274.08 418.74",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.08 418.74 281.99 258.85 280 258.85 272.1 418.74 274.08 418.74",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.98 418.74 246.88 258.85 244.9 258.85 236.99 418.74 238.98 418.74",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.98 418.74 246.88 258.85 244.9 258.85 236.99 418.74 238.98 418.74",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.4,222H381a2.4,2.4,0,0,1,2.42,2.86l-4.09,26.9a3.46,3.46,0,0,1-3.29,2.86H327.44a2.41,2.41,0,0,1-2.43-2.86l4.09-26.9A3.48,3.48,0,0,1,332.4,222Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.65,222h48.64a2.4,2.4,0,0,1,2.42,2.86l-4.09,26.9a3.46,3.46,0,0,1-3.29,2.86H326.69a2.41,2.41,0,0,1-2.43-2.86l4.09-26.9A3.47,3.47,0,0,1,331.65,222Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.65,222h48.64a2.4,2.4,0,0,1,2.42,2.86l-4.09,26.9a3.46,3.46,0,0,1-3.29,2.86H326.69a2.41,2.41,0,0,1-2.43-2.86l4.09-26.9A3.47,3.47,0,0,1,331.65,222Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.69,253.72a1.59,1.59,0,0,1-1.23-.53,1.64,1.64,0,0,1-.35-1.34L329.2,225a2.62,2.62,0,0,1,2.45-2.13h48.64a1.59,1.59,0,0,1,1.23.53,1.64,1.64,0,0,1,.34,1.34l-4.08,26.9a2.62,2.62,0,0,1-2.45,2.13Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.49,253.51H377a.9.9,0,0,1,.91,1.07H311.25A1.3,1.3,0,0,1,312.49,253.51Z",
    style: {
      fill: "#1473E6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.26 405.78 252.89 409.37 245.01 394.11 251.38 390.52 259.26 405.78",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.12,408.11l7.42-3.65a.52.52,0,0,1,.71.21l3.24,5.69a1.31,1.31,0,0,1-.57,1.75c-2.61,1.22-3.92,1.68-7.18,3.28-2,1-6.79,3.45-9.56,4.82s-4-1.42-3-2.25c4.72-3.7,6.84-6.5,8-8.89A2,2,0,0,1,252.12,408.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.38 390.52 245.01 394.11 249.07 401.98 255.64 398.76 251.38 390.52",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.19,240.93s-20.57,41.35-26.74,61.54c-6.75,22.11,25.32,96.94,25.32,96.94l11.71-5.13s-21-74.11-17.35-82.33c10-22.7,33.36-70.54,33.36-70.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,265.72c-5.61,9.41-8,26.37-8.35,37.4,3.17-6.82,6.57-13.92,9.75-20.52h0c2.14-6.29,4.22-12.35,6.16-17.54C261.06,261.47,258.18,258.57,253.93,265.72Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.99 395.15 245.2 401.85 241.53 397.52 256.67 389.46 257.99 395.15",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.34,410.41a9.35,9.35,0,0,0,1.64-1.1.16.16,0,0,0,.06-.18.16.16,0,0,0-.14-.12c-.28-.05-2.78-.41-3.43.31a.66.66,0,0,0-.15.61,1,1,0,0,0,.61.74A2,2,0,0,0,250.34,410.41Zm1.11-1.12c-1.07.82-1.95,1.21-2.41,1.06a.62.62,0,0,1-.38-.5.31.31,0,0,1,.06-.3C249.07,409.17,250.44,409.18,251.45,409.29Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,409.33a.15.15,0,0,0,.06-.05.15.15,0,0,0,0-.17c0-.08-.81-2.05-1.8-2.37a.84.84,0,0,0-.75.11.64.64,0,0,0-.33.74c.2.79,1.86,1.69,2.71,1.76Zm-2.22-2.23a.47.47,0,0,1,.4,0c.59.19,1.17,1.25,1.46,1.88-.81-.2-2-.92-2.11-1.45,0-.1,0-.23.18-.36Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.1,185.49c-1.28,2.59-2.57,4.87-4,7.21s-2.88,4.59-4.48,6.81c-.78,1.12-1.61,2.21-2.42,3.31s-1.7,2.17-2.62,3.22a69.55,69.55,0,0,1-5.79,6.15c-.5.5-1.09,1-1.63,1.45a21.56,21.56,0,0,1-1.7,1.41l-1.81,1.34c-.2.13-.15.12-.76.52a7.91,7.91,0,0,1-1.52.74,7.59,7.59,0,0,1-6.53-.69,7.87,7.87,0,0,1-1.36-1.08,7.09,7.09,0,0,1-.57-.66,4.72,4.72,0,0,1-.4-.56,18.77,18.77,0,0,1-1.2-2.43,29.26,29.26,0,0,1-1.4-4.44,57.72,57.72,0,0,1-1.21-8.3,71.69,71.69,0,0,1-.16-8.17,3.22,3.22,0,0,1,6.34-.67l0,.11a112.1,112.1,0,0,0,4.29,14.15,19.29,19.29,0,0,0,1.39,2.84,7.55,7.55,0,0,0,.68,1c.07.1,0-.09-.11-.17a3.07,3.07,0,0,0-.24-.29,2.8,2.8,0,0,0-.6-.49,3.13,3.13,0,0,0-1.36-.5,3.32,3.32,0,0,0-1.4.13c-.42.09-1.11.62-.65.23l1.2-1.14c.79-.78,1.59-1.62,2.36-2.47a101.92,101.92,0,0,0,8.57-11.68c1.32-2.08,2.63-4.2,3.89-6.33s2.54-4.37,3.66-6.39l.08-.14a6.45,6.45,0,0,1,11.42,6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.44,203a47.68,47.68,0,0,0-1,9c.33-.32.64-.64.95-1a78.83,78.83,0,0,0,6.85-8q1.31-1.72,2.52-3.5c.5-1.27,1-2.54,1.38-3.83.14-.43.27-.84.4-1.27C250.29,192.78,244.39,194.37,242.44,203Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.06,188.07l-.81-5.17-6.43,3a27.41,27.41,0,0,0,1.94,4.94,2.62,2.62,0,0,0,4.19.69h0A3.88,3.88,0,0,0,226.06,188.07Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.63 179.43 216.83 182.74 218.82 185.86 225.25 182.9 221.63 179.43",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.84 415.48 231.67 413.84 234.55 397.01 241.72 398.65 238.84 415.48",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.48,412.92l8.06,1.85a.52.52,0,0,1,.42.61l-1.07,6.47a1.31,1.31,0,0,1-1.55,1c-2.79-.7-4.09-1.17-7.64-2-2.18-.5-8.24-1.65-11.25-2.34s-2.24-3.65-.9-3.63c6,.11,10.21-.68,12.6-1.81A2.06,2.06,0,0,1,231.48,412.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.72 398.66 234.54 397.01 233.06 405.69 240.24 407.33 241.72 398.66",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.56,241.19s-11.85,49.3-15.4,70.11c-3.88,22.78-14.7,91.62-14.7,91.62l13.14,3S260,340.29,265.89,318.2c6.4-24,19.66-53,19.66-76.55C277.61,241.65,260.56,241.19,260.56,241.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.13 406.05 228.11 402.38 228.47 397.21 245.78 402 244.13 406.05",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.65,413.59a9.48,9.48,0,0,0,2,.18.18.18,0,0,0,.16-.1.17.17,0,0,0,0-.19c-.19-.21-1.9-2.06-2.86-1.92a.66.66,0,0,0-.5.39.94.94,0,0,0,0,.95A2,2,0,0,0,228.65,413.59Zm1.57-.17c-1.34,0-2.28-.29-2.54-.7a.64.64,0,0,1,0-.63.33.33,0,0,1,.24-.19C228.45,411.82,229.51,412.7,230.22,413.42Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.59,413.77h.08a.16.16,0,0,0,.12-.11c0-.08.66-2.11.09-3a.85.85,0,0,0-.65-.39.64.64,0,0,0-.72.37c-.35.74.38,2.48,1,3.07Zm-.32-3.14a.52.52,0,0,1,.33.23,3.92,3.92,0,0,1,0,2.39,3.42,3.42,0,0,1-.73-2.46c0-.09.12-.2.37-.17Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.38,181.19a7.19,7.19,0,0,1,5.52-4.82,42.6,42.6,0,0,1,5.53-.84,146,146,0,0,1,16.73.3c2.91.2,5.88.61,8.25,1h.08a4.69,4.69,0,0,1,3.84,5.53,230.5,230.5,0,0,0-4.17,29.77c-.84,14.55-.27,26-.61,29.51l-39.36-.72C244.44,205.34,247.83,189.24,250.38,181.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.05,175.12c-2,7.67-14.64,21.26-16.17,42.61.56,11.71.09,19.7,1.53,27.54l24.1-.64c.37-3.71-2.36-15.64-.57-27.73,1.74-11.72,4.21-27.66,5.61-34.78a5,5,0,0,0-4-5.84h-.09c-2.5-.41-5.63-.85-8.7-1.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.67,233.1a.26.26,0,0,1-.2-.1,39.3,39.3,0,0,1-5.82-10.91.25.25,0,0,1,.16-.32.26.26,0,0,1,.32.17,38.46,38.46,0,0,0,5.74,10.76.25.25,0,0,1-.05.35A.3.3,0,0,1,282.67,233.1Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.69,191.09c-1.72,7-1.13,16.69.3,25.53,1.47-9.92,3.46-22.8,4.87-30.78C289.19,184.7,287.05,185.51,285.69,191.09Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.36,181.33a8.28,8.28,0,0,1,6.06-5.51,74.18,74.18,0,0,1,7.93-.67c-2.24,7.26-.93,28.51.06,45.28-3,8.46-2.77,14.67-2.82,24.84l-16.49-1.44C241.3,206.52,245.89,188.11,248.36,181.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.22,175.48c4.89-1.06,5.8-4,5.53-7.36a19.52,19.52,0,0,0-.34-2.47l6.19-5,4.54-3.63c-1.34,5.36-2.92,15.16.66,18.82,0,0-3.11,4.91-11.42,4.31C260.35,179.69,262.22,175.48,262.22,175.48Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.52 178.96 268.14 180.24 272.4 181.85 271.89 180.22 269.52 178.96",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.07,184.05s0-4.19-1.55-5.09a18.37,18.37,0,0,0,8.45-4.61l2.53,1S279.57,180.19,271.07,184.05Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.17 178.63 268.14 180.24 263.61 180.63 264.55 179.2 267.17 178.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.32,183.19a6.51,6.51,0,0,1,3.85-4.56c-2.44-.73-2.51-4.12-2.51-4.12l-2.39.46S259.82,179.49,263.32,183.19Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.41,165.65a19.28,19.28,0,0,1,.34,2.47c2.28-.42,5.36-2.78,5.72-5.1a10.26,10.26,0,0,0,.13-2.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.06,141.14a8.36,8.36,0,0,0,.34,8.52l4.9-6.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.83,147.91c-.35,7.32-.18,11.6-3.81,15.53a9.53,9.53,0,0,1-16.33-4.2c-1.65-6.48-.81-17.36,6.28-20.61A9.64,9.64,0,0,1,278.83,147.91Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.33,140.37c-3.16-10.12-34.67-15.35-22.45,1.77l13.4-1.83.5,3.44a47.58,47.58,0,0,0,2.74,7.85l-.56,3.11.58,5.06s5.57-6.18,8.39-9.11C290.15,146.3,285.87,140.12,283.33,140.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.32,142.37c3.5,2.58,12.65,3.07,12.65,3.07a8.76,8.76,0,0,0-2.79-3.4c3.67,2.38,6.93,5.12,13.06,5.35a17.75,17.75,0,0,0-9.58-10.22C265.28,133.86,252.75,137.54,259.32,142.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.86,131.41s-1.36.92-1.67,4.12,2.93,7.33,2.93,7.33l.8-2.05C280.89,136.9,281.86,131.41,281.86,131.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.88,153.43a6.88,6.88,0,0,1-3.14,3.39c-1.79.88-2.74-.74-2.28-2.72.41-1.78,1.85-4.38,3.67-4.44S281.66,151.59,280.88,153.43Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.65,150.63c0,.59-.3,1.09-.68,1.11s-.71-.45-.72-1.05.3-1.09.69-1.11S267.64,150,267.65,150.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,151c0,.6-.3,1.09-.69,1.11s-.71-.45-.71-1,.3-1.09.68-1.11S260.94,150.36,261,151Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.24,151a22.12,22.12,0,0,1-2.76,5.22,3.38,3.38,0,0,0,2.84.4Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.76,158.1a5.07,5.07,0,0,0,3.4-2.12.18.18,0,0,0-.05-.24.17.17,0,0,0-.24.06,5,5,0,0,1-3.81,2,.19.19,0,0,0-.17.19.18.18,0,0,0,.18.16A4.88,4.88,0,0,0,265.76,158.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.67,148.08a.37.37,0,0,0,.16-.07.35.35,0,0,0,.05-.49,3.35,3.35,0,0,0-2.86-1.31.35.35,0,1,0,.08.69,2.69,2.69,0,0,1,2.24,1A.33.33,0,0,0,270.67,148.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,148.87a.35.35,0,0,0,.26-.2,2.91,2.91,0,0,1,2-1.68.34.34,0,0,0,.28-.4.35.35,0,0,0-.4-.29h0a3.62,3.62,0,0,0-2.46,2.08.35.35,0,0,0,.37.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.67,180.62c.67,1.5,1.24,2.86,1.79,4.29s1.1,2.85,1.62,4.28c1,2.86,2,5.77,2.8,8.72a89.84,89.84,0,0,1,3.46,18.46,164,164,0,0,1,0,18.15c-.29,6-.76,11.87-1.55,17.8a3.22,3.22,0,0,1-6.39-.06v0c-.65-5.84-1.16-11.7-1.69-17.51q-.39-4.36-.84-8.67c-.27-2.87-.63-5.72-1-8.43a103.62,103.62,0,0,0-4.16-16c-.9-2.67-1.83-5.35-2.82-8s-2.05-5.37-3-7.88l-.06-.14a6.46,6.46,0,0,1,11.9-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.5,251.82l-4.17,2,7.07,2.53s4.79-1.51,2.54-4.15l-1.26-.4C296.63,251.11,295.62,251.18,294.5,251.82Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.94 258.3 295.41 259.73 297.4 256.31 290.33 253.78 287.94 258.3",
    style: {
      fill: "#ffb573"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chat--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.27,
    y: 85.11,
    width: 33.55,
    height: 1.12,
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.72,91l-.82-.77a16.34,16.34,0,0,1,12-5.15v1.11A15.2,15.2,0,0,0,122.72,91Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.94,89h64.14a14.51,14.51,0,0,1,14.23,13.39l2.43,38.4.78,12.46L202.28,140.8H137.22A14.5,14.5,0,0,1,123,127.42l-1.58-25A12.45,12.45,0,0,1,133.94,89Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.33,107.35h60.61a2.08,2.08,0,0,0,2.09-2.23h0a2.43,2.43,0,0,0-2.38-2.23h-60.6a2.08,2.08,0,0,0-2.09,2.23h0A2.42,2.42,0,0,0,137.33,107.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,117.63h60.61a2.08,2.08,0,0,0,2.09-2.23h0a2.42,2.42,0,0,0-2.38-2.23H137.7a2.07,2.07,0,0,0-2.09,2.23h0A2.42,2.42,0,0,0,138,117.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.27,127.91h40a2.08,2.08,0,0,0,2.09-2.24h0a2.41,2.41,0,0,0-2.37-2.23H159a2.08,2.08,0,0,0-2.09,2.23h0A2.41,2.41,0,0,0,159.27,127.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.69,153.26H92.55A12.44,12.44,0,0,0,80,166.64L81.8,194.8l.78,12.45L94.25,194.8h65.06a12.45,12.45,0,0,0,12.54-13.39l-.93-14.77A14.5,14.5,0,0,0,156.69,153.26Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.69,153.26H92.55A12.44,12.44,0,0,0,80,166.64L81.8,194.8l.78,12.45L94.25,194.8h65.06a12.45,12.45,0,0,0,12.54-13.39l-.93-14.77A14.5,14.5,0,0,0,156.69,153.26Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.62,171.6H95a2.42,2.42,0,0,1-2.37-2.23h0a2.08,2.08,0,0,1,2.09-2.23h60.6a2.42,2.42,0,0,1,2.38,2.23h0A2.08,2.08,0,0,1,155.62,171.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.63,181.9h-40a2.43,2.43,0,0,1-2.38-2.23h0a2.08,2.08,0,0,1,2.09-2.23h40a2.4,2.4,0,0,1,2.37,2.23h0A2.08,2.08,0,0,1,135.63,181.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.42,207.25h64.13a14.5,14.5,0,0,1,14.23,13.39l1.9,30,.79,12.45-13.24-12.45H144.16a14.51,14.51,0,0,1-14.23-13.39l-1.05-16.65A12.45,12.45,0,0,1,141.42,207.25Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.05,227.36a5.08,5.08,0,0,0,5,4.71,4.38,4.38,0,0,0,4.42-4.71,5.1,5.1,0,0,0-5-4.71A4.37,4.37,0,0,0,170.05,227.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.34,228.94a5.08,5.08,0,0,0,5,4.71,4.37,4.37,0,0,0,4.41-4.71,5.1,5.1,0,0,0-5-4.71A4.37,4.37,0,0,0,154.34,228.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.1,231.31a5.1,5.1,0,0,0,5,4.71,4.37,4.37,0,0,0,4.41-4.71,5.08,5.08,0,0,0-5-4.71A4.38,4.38,0,0,0,186.1,231.31Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNochat);
export default __webpack_public_path__ + "static/media/nochat.d55ab89f658551033337246ec46b5454.svg";
export { ForwardRef as ReactComponent };